<div class="modal-reservation-visite">
    <ng-template #content let-modal>
        <div class="modal-header-bg">
            <div class="modal-header container">
                <h4 class="modal-title" aria-label="The Door Man">
                    <img width="109" height="51" src="../../../../assets/logo/logo-white.svg" alt="The Door Man">
                    <span class="visually-hidden">The Door Man</span>
                </h4>
                <button type="button" class="btn-close btn-close-white me-1" aria-label="Close"
                    (click)="modal.dismiss('Cross click')"></button>
                <span>Quitter</span>
            </div>
        </div>
        <div class="modal-body p-0 pb-5">
            <div class="slider-bg-img gradient01 pb-5">
                <div class="container row-cols-md-2 row-cols-sm-1 text-white py-4 py-md-5">
                    <div>
                        <h2 *ngIf="!userConnected?.type || userConnected?.type?.id == 5" class="heading text-uppercase py-2">
                            Réservez votre visite avec
                          <span style="color:#BADFFF" *ngIf="agentBien && !agentBien.is_bytdm">{{ agentBien.name }}</span>
                          <span style="color:#BADFFF" *ngIf="agentBien && agentBien.is_bytdm">{{bien.club?.info?.le_nom}} {{bien.club?.info?.reseau_nom}} {{bien.club?.nom}}</span>
                        </h2>
                        <h2 *ngIf="userConnected?.type && userConnected?.type?.id != 5" class="heading text-uppercase py-2">
                            Réservez votre visite avec <span style="color:#BADFFF">
                          {{ userConnected.agent_create?.prenom }} {{ userConnected.agent_create?.nom }}</span>
                        </h2>
                        <span>
                            Intéressé par un bien ? Complétez le formulaire qui suit pour être recontacté au plus vite
                          par notre
                          <span *ngIf="!userConnected?.type || userConnected?.type?.id == 5">{{ agentBien?.fct | lowercase }}.</span>
                          <span *ngIf="userConnected?.type && userConnected?.type?.id != 5">{{ userConnected.agent_create?.fct | lowercase }}</span>
                        </span>
                    </div>
                </div>
            </div>
            <div class="container">
                <div class="row form-container">
                    <div class="col-md-8 mb-2">
                        <div class="card p-2 mb-2">
                            <div class="card-body" [formGroup]="visitForm">
                                <h5 class="fw-bold">Vos coordonnées</h5>
                                <div class="row my-3">
                                    <div class="col-sm-6 mb-1">
                                        <label for="nom" class="form-label">Nom</label>
                                        <input placeholder="Ex : Dupont" type="text" class="form-control" id="nom"
                                            formControlName="lastName"
                                            [ngClass]="{ 'is-invalid': submitted && f.lastName.errors }">
                                        <div *ngIf="submitted && f.lastName.errors" class="invalid-feedback">
                                            <div *ngIf="f.lastName.errors.required">Champ obligatoire</div>
                                        </div>
                                    </div>
                                    <div class="col-sm-6 mb-1">
                                        <label for="prenom" class="form-label">Prénom</label>
                                        <input placeholder="Ex : Marc" type="text" class="form-control" id="prenom"
                                            formControlName="firstName"
                                            [ngClass]="{ 'is-invalid': submitted && f.firstName.errors }">
                                        <div *ngIf="submitted && f.firstName.errors" class="invalid-feedback">
                                            <div *ngIf="f.firstName.errors.required">Champ obligatoire</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row my-3">
                                    <div class="col-sm-6 mb-1">
                                        <label for="tel" class="form-label">Téléphone</label>
                                        <input placeholder="Ex : 0602030405" type="tel" class="form-control" id="tel"
                                            formControlName="phone"
                                            [ngClass]="{ 'is-invalid': submitted && f.phone.errors }">
                                        <div *ngIf="submitted && f.phone.errors" class="invalid-feedback">
                                            <div *ngIf="f.phone.errors.required">Champ obligatoire</div>
                                            <div *ngIf="f.phone.errors.pattern">veuillez saisir un numéro de téléphone
                                                valide</div>
                                        </div>
                                    </div>
                                    <div class="col-sm-6 mb-1">
                                        <label for="email" class="form-label">Email</label>
                                        <input placeholder="Ex : marc.dupont@mail.com" type="email" class="form-control"
                                            id="email" formControlName="email"
                                            [ngClass]="{ 'is-invalid': submitted && f.email.errors }">
                                        <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                                            <div *ngIf="f.email.errors.required">Champ obligatoire</div>
                                            <div *ngIf="f.email.errors.pattern">Veuillez saisir une adresse e-mail
                                                valide</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="my-3">
                                    <span class="fw-bold my-3">Quand êtes-vous disponible pour une visite ?</span>
                                    <div class="col-sm-12 mt-2"
                                        [ngClass]="{ 'is-invalid': submitted && f.disponibility.errors }">
                                        <div class="form-check form-check-inline">
                                            <input class="form-check-input" type="radio" name="disponibility"
                                                id="inlineRadioDisponible1" value="1" formControlName="disponibility">
                                            <label class="form-check-label" for="inlineRadioDisponible1">Le
                                                matin</label>
                                        </div>
                                        <div class="form-check form-check-inline">
                                            <input class="form-check-input" type="radio" name="disponibility"
                                                id="inlineRadioDisponible2" value="2" formControlName="disponibility">
                                            <label class="form-check-label"
                                                for="inlineRadioDisponible2">L’après-midi</label>
                                        </div>
                                        <div class="form-check form-check-inline">
                                            <input class="form-check-input" type="radio" name="disponibility"
                                                id="inlineRadioDisponible3" value="3" formControlName="disponibility">
                                            <label class="form-check-label" for="inlineRadioDisponible3">Peu
                                                importe</label>
                                        </div>
                                    </div>
                                    <div *ngIf="submitted && f.disponibility.errors" class="invalid-feedback">
                                        <div *ngIf="f.disponibility.errors.required">Champ obligatoire</div>
                                    </div>
                                </div>
                                <div *ngIf="!isPartnerV" class="my-3">
                                    <span class="fw-bold my-3">Êtes-vous primo-accédant (il s’agit de votre premier
                                        achat immobilier) ?</span>
                                    <div class="col-sm-12 mt-2"
                                        [ngClass]="{ 'is-invalid': submitted && f.access.errors }">
                                        <div class="form-check form-check-inline">
                                            <input class="form-check-input" type="radio" name="access"
                                                formControlName="access" id="inlineRadioAccedant1" value="1">
                                            <label class="form-check-label" for="inlineRadioAccedant1">Oui</label>
                                        </div>
                                        <div class="form-check form-check-inline">
                                            <input class="form-check-input" type="radio" name="access"
                                                formControlName="access" id="inlineRadioAccedant2" value="2">
                                            <label class="form-check-label" for="inlineRadioAccedant2">Non</label>
                                        </div>
                                    </div>
                                    <div *ngIf="submitted && f.access.errors" class="invalid-feedback">
                                        <div *ngIf="f.access.errors.required">Champ obligatoire</div>
                                    </div>
                                </div>
                                <div *ngIf="!isPartnerV" class="my-3">
                                    <span class="fw-bold my-3">Avez-vous un bien à vendre ?</span>
                                    <div class="col-sm-12 mt-2"
                                        [ngClass]="{ 'is-invalid': submitted && f.saler.errors }">
                                        <div class="form-check form-check-inline">
                                            <input class="form-check-input" type="radio" name="saler"
                                                formControlName="saler" id="inlineRadioAVendre1" value="1">
                                            <label class="form-check-label" for="inlineRadioAVendre1">Oui</label>
                                        </div>
                                        <div class="form-check form-check-inline">
                                            <input class="form-check-input" type="radio" name="saler"
                                                formControlName="saler" id="inlineRadioAVendre2" value="2">
                                            <label class="form-check-label" for="inlineRadioAVendre2">Non</label>
                                        </div>
                                    </div>
                                    <div *ngIf="submitted && f.saler.errors" class="invalid-feedback">
                                        <div *ngIf="f.saler.errors.required">Champ obligatoire</div>
                                    </div>
                                </div>
                                <div *ngIf="!isPartnerV" class="my-3">
                                    <span class="fw-bold my-3">Avez-vous déjà entamé des démarches financières ?</span>
                                    <div class="col-sm-12 mt-2"
                                        [ngClass]="{ 'is-invalid': submitted && f.financier.errors }">
                                        <div class="form-check form-check-inline">
                                            <input class="form-check-input" type="radio" name="financier"
                                                formControlName="financier" id="inlineRadioDemarche1" value="1">
                                            <label class="form-check-label" for="inlineRadioDemarche1">Oui</label>
                                        </div>
                                        <div class="form-check form-check-inline">
                                            <input class="form-check-input" type="radio" name="financier"
                                                formControlName="financier" id="inlineRadioDemarche2" value="2">
                                            <label class="form-check-label" for="inlineRadioDemarche2">Non</label>
                                        </div>
                                    </div>
                                    <div *ngIf="submitted && f.financier.errors" class="invalid-feedback">
                                        <div *ngIf="f.financier.errors.required">Champ obligatoire</div>
                                    </div>
                                </div>
                                <div *ngIf="!isPartnerV" class="my-3">
                                    <span class="fw-bold my-3">Souhaitez-vous être mis en relation avec notre partenaire
                                        crédits In&Fi (étude gratuite et sans engagement) ? <span
                                            class="text-black-50">(facultatif)</span> </span>
                                    <div class="col-sm-12 mt-2">
                                        <div class="form-check form-check-inline">
                                            <input class="form-check-input" type="radio" name="contactTdm"
                                                formControlName="contactTdm" id="inlineRadioRelatio1" value="1">
                                            <label class="form-check-label" for="inlineRadioRelatio1">Oui</label>
                                        </div>
                                        <div class="form-check form-check-inline">
                                            <input class="form-check-input" type="radio" name="contactTdm"
                                                formControlName="contactTdm" id="inlineRadioRelatio2" value="2">
                                            <label class="form-check-label" for="inlineRadioRelatio2">Non</label>
                                        </div>
                                    </div>
                                </div>
                                <div class="row my-3">
                                    <label for="message" class="form-label">Votre message <span class="text-black-50">
                                            (facultatif) </span> </label>
                                    <textarea placeholder="Précisez votre demande en quelques mots..."
                                        formControlName="comment" class="form-control mx-2" id="message"></textarea>
                                </div>
                                <div *ngIf="!isPartnerV" class="my-4">
                                    <div class="py-3 form-check"
                                        [ngClass]="{ 'is-invalid': submitted && f.terms.errors }">
                                        <input class="form-check-input" type="checkbox" value="" formControlName="terms"
                                            id="flexCheckIndeterminate">
                                        <label class="form-check-label" for="flexCheckIndeterminate">
                                            J'accepte que mes données personnelles soient traitées par THE DOOR MAN pour
                                            donner suite à ma demande.
                                        </label>
                                    </div>
                                    <div *ngIf="submitted && f.terms.errors" class="invalid-feedback">
                                        <div *ngIf="f.terms.errors.required">Champ obligatoire</div>
                                    </div>
                                </div>
                                <div class="my-3">
                                    <button class="btn btn-gold px-4 py-2" (click)="submitFormVisit()">Envoyer ma
                                        demande</button>
                                </div>
                                <div *ngIf="!isPartnerV" class="my-4">
                                    <p class="condition">
                                      En envoyant cette demande, j'accepte que mes données personnelles soient utilisées
                                      pour me recontacter dans le cadre de la demande indiquée dans ce formulaire.<br>
                                      Aucun autre traitement ne sera effectué avec mes informations.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 mb-2">
                        <div class="card shadow-sm mb-3 p-2 mb-2">
                            <div class="card-body">
                                <h5 class="card-title text-black fw-bold">Bien à visiter</h5>
                                <div class="row py-3">
                                    <div class="col-sm-5">
                                        <img *ngIf="bien?.thumbnail?.path" class="w-100" [src]="bien.thumbnail.path">
                                    </div>
                                    <div class="col-sm-7">
                                        <div class="text-black fw-bolder pb-2">{{bien.ville | uppercase}}</div>
                                        <div class="options-bien pb-2">
                                            <span *ngIf="bien.property.size_generique" class="pe-3">
                                                <span class="text-bleu-tdm fw-semibold">
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M9 5H5V9" stroke="#131313" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M15.5 19H19V15.5" stroke="#131313" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M8.5 19H5V15.5" stroke="#131313" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M10 14.5L5 19" stroke="#131313" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M15.5 5H19V8.5" stroke="#131313" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M14 9.5L19 5" stroke="#131313" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>&nbsp;{{bien.property.size_generique}}&nbsp;m²</span>
                                            </span>
                                            <span class="pe-3" *ngIf="bien.property.pieces">
                                                <span class="text-bleu-tdm fw-semibold">
                                                    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M11.0002 8.70835V5.04169H1.8335V17.875H19.2502V5.04169H15.1252" stroke="#131313" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M7.3335 17.875L7.3335 11" stroke="#131313" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M19.2498 11.4583H13.2915" stroke="#131313" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
                                                    </svg>&nbsp;{{bien.property.pieces}}&nbsp;p
                                                </span>
                                            </span>
                                            <span class="pe-3" *ngIf="bien.property.room">
                                                <span
                                                    class="text-bleu-tdm fw-semibold">
                                                    <svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <g clip-path="url(#clip0_4559_36601)">
                                                    <path d="M20.9453 20.0103L19.3907 17.5745H4.27721L2.86396 19.9521C2.73926 20.1599 2.41504 20.0768 2.41504 19.8274V11.4975C2.41504 11.2648 2.60624 11.0735 2.83902 11.0735H20.9619C21.1947 11.0735 21.3859 11.2648 21.3859 11.4975V19.8856C21.3859 20.1267 21.07 20.2181 20.9453 20.0186V20.0103Z" stroke="#131313" stroke-width="1.4" stroke-miterlimit="10"/>
                                                    <path d="M3.44629 11.0736V5.18779L3.62918 5.13791C9.05775 3.78285 14.7357 3.79116 20.156 5.16285L20.2557 5.18779V11.0736" stroke="#131313" stroke-width="1.4" stroke-miterlimit="10"/>
                                                    <path d="M13.3218 11.0736V10.0344C13.3218 8.65441 14.4441 8.21381 15.8241 8.21381C17.2041 8.21381 18.3264 8.65441 18.3264 10.0344V11.0736" stroke="#131313" stroke-width="1.4" stroke-miterlimit="10"/>
                                                    <path d="M5.2998 11.0736V10.0344C5.2998 8.65441 6.41378 8.21381 7.79379 8.21381C9.17379 8.21381 10.2961 8.65441 10.2961 10.0344V11.0736" stroke="#131313" stroke-width="1.4" stroke-miterlimit="10"/>
                                                    </g>
                                                    <defs>
                                                    <clipPath id="clip0_4559_36601">
                                                    <rect width="21.1645" height="18" fill="white" transform="translate(1.32275 3.125)"/>
                                                    </clipPath>
                                                    </defs>
                                                    </svg>&nbsp;{{bien.property.room}}&nbsp;ch
                                                </span>
                                            </span>
                                        </div>
                                        <div class="pb-2">
                                            <span class="text-bleu-tdm h4 fw-bolder">{{bien.property.price_formatted}}&nbsp;€</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="bg-white p-3 rounded-1 shadow-sm card mb-3">
                            <div class="row ">
                                <div class="col-4">
                                    <div
                                        class="position-relative rounded-circle overflow-hidden mx-auto custom-circle-image">
                                        <img class="w-100 h-100"
                                            *ngIf="!bien?.local_market_expert?.invisible_front && agentBien?.urlphoto !== null && agentBien?.urlphoto !== ''"
                                            [src]="agentBien.urlphoto" />
                                        <img width="512" height="512" class="w-100 h-100" *ngIf="bien?.local_market_expert?.invisible_front"
                                            src="../../../../assets/resources/web/images/data/s-personne.png" />
                                    </div>
                                </div>
                                <div class="col-8" style="align-self: center;">
                                    <!--Visible front-->
                                    <div *ngIf="!bien?.local_market_expert?.invisible_front && !bien?.local_market_expert?.is_bytdm"
                                        class="col-sm-12 align-self-center ">
                                        <h5 class="text-bleu-tdm fw-bolder">{{ agentBien?.name }}</h5>
                                        <h5>{{ agentBien?.fct }} (EI)</h5>
                                    </div>
                                    <!--Invisible front-->
                                    <div *ngIf="bien?.local_market_expert?.invisible_front && !bien?.local_market_expert?.is_bytdm"
                                        class="col-sm-12 align-self-center ">
                                        <h5 class="text-bleu-tdm fw-bolder">THE DOOR MAN FRANCE</h5>
                                    </div>
                                    <!--byTDM-->
                                    <div *ngIf="bien?.local_market_expert?.is_bytdm"
                                        class="col-sm-12 align-self-center ">
                                        <h5 class="text-bleu-tdm fw-bolder">{{bien.club?.nom}}</h5>
                                    </div>
                                </div>
                            </div>
                            <div class="bg-light border my-4"></div>
                            <div class="row profile-info">
                                <div>
                                    <span class="pe-3"><i class="bi bi-telephone text-bleu-tdm pe-3"></i>
                                        <span *ngIf="!bien?.local_market_expert?.invisible_front && !bien?.local_market_expert?.is_bytdm"
                                            class="text-bleu-tdm fw-semibold">
                                            {{ agentBien?.telephoneTransfer | phone}}
                                        </span>
                                        <span *ngIf="bien?.local_market_expert?.invisible_front && !bien?.local_market_expert?.is_bytdm"
                                            class="text-bleu-tdm fw-semibold">
                                            01 30 46 69 70
                                        </span>
                                        <!-- byTDM -->
                                        <span *ngIf="bien?.local_market_expert?.is_bytdm"
                                            class="text-bleu-tdm fw-semibold">{{bien.club?.telephone | phone}}
                                        </span>
                                    </span>
                                </div>
                                <div>
                                    <span class="pe-3"><i class="bi bi-envelope text-bleu-tdm pe-3"></i>
                                        <span>
                                            <app-modal-contact [ami]="bien.local_market_expert"></app-modal-contact>
                                        </span>
                                    </span>
                                </div>
<!--                                <div>-->
<!--                                    <span class="pe-3"><i class="bi bi-geo-alt text-bleu-tdm pe-3"></i>-->
<!--                                        <span>{{ agentBien?.club_name}}</span>-->
<!--                                    </span>-->
<!--                                </div>-->

                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </ng-template>
    <button [class]="classCss" id="clickBtn" (click)="openFullscreen(content)">{{textBtn}}</button>
</div>
